import { Router, type CanActivateFn } from "@angular/router";
import { AppType } from "../enums/app-type.enum";
import { environment } from "../../environments/environment";
import { inject } from "@angular/core";
import { RoutingPaths } from "../enums/routing-paths.enum";

export const appTypeGuard = (appType: AppType): CanActivateFn => {
  
  return (route, state) => {
    const router = inject(Router);
    return environment.appType === appType
      ? true
      : router.createUrlTree([RoutingPaths.myhome]);
  };
};
